import styled from 'styled-components';
import {theme} from './../../../styles/theme';

interface ResponsiveProps {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
}

export const StyledWrapper = styled.div<ResponsiveProps>`
  display: flex;
  align-items: center;
  margin: 0 auto;
  gap: ${({ isMobileMini, isMobileMedium }) =>
    isMobileMini ? '2px' : isMobileMedium ? '6px' : '10px'};
  width: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini
      ? '80px'
      : isMobileMedium
      ? '150px'
      : isMobileBig
      ? '280px'
      : isMiniNotebook
      ? '340px'
      : '400px'};
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    opacity: 0.7;
  }
`;


export const StyledButton = styled.button<ResponsiveProps>`
  padding: ${({ isMobileMini, isMobileMedium }) =>
    isMobileMini ? 'auto auto' : isMobileMedium ? 'auto auto' : 'auto auto'};
  font-size: ${({ isMobileMini, isMobileMedium, isMobileBig }) =>
    isMobileMini ? '0px' : isMobileMedium ? '9px' : isMobileBig ? '12px' : '16px'};
  height: ${({ isMobileMini, isMobileMedium, isMobileBig }) =>
    isMobileMini ? '16px' : isMobileMedium ? '20px' : isMobileBig ? '22px' : '24px'};
  width: ${({ isMobileMini, isMobileMedium, isMobileBig }) =>
    isMobileMini ? '30px' : isMobileMedium ? '42px' : isMobileBig ? '52px' : '64px'};
  background-color:${({ isMobileMini, isMobileMedium, isMobileBig }) =>
    isMobileMini ? 'transparent' : isMobileMedium ? theme.colors.primary : isMobileBig ? theme.colors.primary : theme.colors.primary};  
  //background-color: ${({ theme }) => theme.colors.primary};
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
  text-align: center;
  
  svg { /* Estiliza o ícone quando estiver visível */
    display: ${({ isMobileMini }) => (isMobileMini ? 'block' : 'none')};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary};
  }
`;

